import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahvocationalcourse',
  templateUrl: './asahvocationalcourse.component.html',
  styleUrls: ['./asahvocationalcourse.component.scss']
})
export class AsahvocationalcourseComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
